import React from 'react';
import styled from '@emotion/styled';
import { Link } from '@modernhealth/vital-components';

const inheritColorStyles = `
    color: inherit;

    :hover {
        color: inherit;
      }
`;

const StyledLink = styled.a<{ inheritColor: boolean }>`
    font-size: inherit;

    ${props => props.inheritColor && inheritColorStyles}
`;

export const InlineButtonLink: React.FC<{ onClick: () => void; inheritColor?: boolean }> = ({
    onClick,
    inheritColor = false,
    children,
}) => (
    <Link>
        <StyledLink
            href="#"
            role="button"
            onClick={e => {
                e.preventDefault();
                onClick();
            }}
            inheritColor={inheritColor}
        >
            {children}
        </StyledLink>
    </Link>
);
